import React from "react";
import { ReactComponent as Close } from "assets/svgs/close.svg";
import { useSettings } from "hooks/useStore";
import NotificationSlider from "components/notification-slider";

const CartHeader = ({ announcementBar }) => {
	const { toggleCart } = useSettings(["toggleCart"]);
	const beigeStyle = announcementBar.style === "gold";

	return (
		<div className="bg-white">
			<div className="flex justify-between w-full p-3">
				<p />
				<h5 className="font-medium">YOUR CART</h5>
				<button onClick={toggleCart}>
					<Close className="size-4" />
				</button>
			</div>
			<div>
				<NotificationSlider className="h-6 flex justify-center"
					slides={announcementBar?.slides} beigeStyle={beigeStyle} showArrows={false} textClass="md:text-sm" />
			</div>
		</div>
	);
};

export default CartHeader;